import Vue from 'vue';
import IdleVue from 'idle-vue';
import appSettings from '@/plugins/appSettings';
import store from '@/store';

const eventsHub = new Vue();
const timeout = appSettings.applicationSettings.idleTimeout;
Vue.use(IdleVue, {
  store,
  eventEmitter: eventsHub,
  idleTime: timeout,
});

export default new Vue({
  data() {
    return {
      logoutConfirm: false,
    };
  },
  onIdle() {
    this.logoutConfirm = !this.logoutConfirm;
  },
});
